import noUiSlider from 'nouislider';

class Slider {
  constructor(node, keys, options = {}) {
    this.node = node;
    this.keys = keys;
    this.options = options;
    this.setRange();
    this.create();
  }

  setRange() {
    const range = JSON.parse(this.node
      .getAttribute('data-slider-range'));
    const [initialFrom, initialTo] = this.node
      .getAttribute('data-slider-initial')
      .split('|')
      .map((p) => Number(p));

    this.range = range;
    this.initialFrom = initialFrom;
    this.initialTo = initialTo;
    this.defaultValue = this.node.getAttribute('data-slider-default');
  }

  create() {
    noUiSlider.create(this.node, {
      start: this.initialTo ? [this.initialFrom, this.initialTo] : this.initialFrom,
      connect: this.initialTo ? true : [true, false],
      range: this.range,
      format: {
        from: (value) => Math.round(value),
        to: (value) => Math.round(value),
      },
      ...(this.options.step && {step: this.options.step})
    });

    this.node.noUiSlider.on('update', () => {
      const values = this.node.noUiSlider.get();
      this.options.onUpdate(Array.isArray(values) ? { min: values[0], max: values[1] } : values);
    });

    this.node.noUiSlider.on('change', (values) => {
      if (this.initialTo) {
        if (Number(values[0]) === this.range.min) {
          this.options.onChange(this.keys[0], false);
        } else {
          this.options.onChange(this.keys[0], Number(values[0]));
        }

        if (Number(values[1]) === this.range.max) {
          this.options.onChange(this.keys[1], false);
        } else {
          this.options.onChange(this.keys[1], Number(values[1]));
        }
      } else {
        this.options.onChange(this.keys[0], Number(values[0]));
      }
    });
  }

  reset() {
    this.node.noUiSlider.set(this.defaultValue ? [this.defaultValue] : [this.range.min, this.range.max]);
  }
}

export default Slider;
